import { plural } from '@cian/utils';
import { NBSP } from '../../../../../constants/symbols';
import { formatMoney } from '../../../../../utils/string';

interface IParams {
  price: number;
  days?: number;
}

export const getValue = ({ price, days }: IParams) => {
  const formattedSum = formatMoney(price);
  const period = days && plural(days, ['в день', `за ${days} дня`, `за ${days} дней`]);

  return [formattedSum, period]
    .filter(Boolean)
    .join(' ')
    .replace(' ', NBSP);
};
